import { Button } from "@heroui/react";

import { MoonIcon, SunIcon } from "@/src/components/icons";
import { useTheme } from "@/src/hooks/useTheme";
import { useTranslations } from "@/src/i18n/i18n";

/**
 * Bascule clair / sombre.
 *
 * Le libellé décrit **l'action**, pas l'état affiché : « Passer en thème
 * clair » quand on est en sombre. C'est ce qu'attend un lecteur d'écran d'un
 * contrôle iconique, et l'icône montre déjà la destination.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const ta = useTranslations("a11y");
  const goesToLight = theme === "dark";

  return (
    <Button
      aria-label={ta(goesToLight ? "to-light-theme" : "to-dark-theme")}
      className={className}
      isIconOnly
      size="sm"
      variant="ghost"
      onPress={toggleTheme}
    >
      {goesToLight ? (
        <SunIcon className="size-4" />
      ) : (
        <MoonIcon className="size-4" />
      )}
    </Button>
  );
}
